import { Component, computed, inject, input, InputSignal } from '@angular/core';
import { ResolutionService } from '../resolution.service';

@Component({
  selector: 'app-empty-message',
  imports: [],
  template: `
    <div class="d-grid" [class.mt-4]="!mt0">
      <div class="alert alert-warning w-auto d-flex align-items-center gap-2 animated fadeIn flex-nowrap" role="alert"
        [class.p-1]="tinny()"
        [class.mb-0]="alertMartginBottom0()"
        [class.mb-2]="marginBottom2()"
        [class.w-max-content]="!isMobile() && !width100()">
        @if(displayIcon()) {
          <i class="fa fa-info-circle text-primary"></i>
        }
        @if (isHtml()) {
          <div class="text-wrap" [class.h7-regular]="!shouldShowSmallText()" [class.h8-regular]="shouldShowSmallText()" [innerHTML]="message()"></div>
        } @else {
          <div class="text-wrap" [class.h7-regular]="!shouldShowSmallText()" [class.h8-regular]="shouldShowSmallText()">
            {{message()}}
          </div>
        }
      </div>
  </div>`
})
export class EmptyMessageComponent {

  #resolutionService = inject(ResolutionService);

  isMobile = computed(() => this.#resolutionService.isMobile());

  message: InputSignal<string> = input('No results found');
  width100: InputSignal<boolean> = input(false);
  mt0: InputSignal<boolean> = input(false);
  isHtml: InputSignal<boolean> = input(false);
  displayIcon: InputSignal<boolean> = input(true);
  marginTop0: InputSignal<boolean> = input(false);
  alertMartginBottom0: InputSignal<boolean> = input(false);
  tinny: InputSignal<boolean> = input(false);
  shouldShowSmallText: InputSignal<boolean> = input(false);
  marginBottom2: InputSignal<boolean> = input(false);

}
